import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classnames from 'classnames';
import { BalloonBasic } from '../BalloonBasic/index.js';
import cssClasses from './index.module.scss.js';

let TOOLTIP_COUNTER = 0;
/**
 * A contextual text bubble that displays a description for an element that appears on pointer hover or keyboard focus.
 * Because the tooltip itself never receives focus and is not in the tabbing order, a tooltip can not contain interactive elements like links, inputs, or buttons.
 *
 * **Our version includes a button as interactive element.**
 *
 * A tooltip typically becomes visible, after a short delay of generally one to five seconds, in response to a mouse hover, or after the owning element receives keyboard focus. Just as it is opened automatically, without user request, it is closed automatically when the focus is lost or on mouse out. It should also close when the user presses the Escape key._
 */
function Tooltip({ label, children, classes = [], balloonClasses = [], arrowPosition, type, }) {
    const tooltipId = useMemo(() => `description-${++TOOLTIP_COUNTER}`, []);
    return (jsxs("button", { className: classnames({
            [cssClasses[arrowPosition]]: true,
            [cssClasses['tooltip-wrapper']]: true,
            [cssClasses['show-on-hover']]: true,
        }, classes), "aria-describedby": tooltipId, onClick: (e) => e.preventDefault(), children: [children, jsx(BalloonBasic, { id: tooltipId, classes: [cssClasses['tooltip'], ...balloonClasses], arrowPosition: arrowPosition, type: type, children: label })] }));
}

export { Tooltip };
//# sourceMappingURL=index.js.map
